import { money } from 'services/graphql/fragments/Fragments';
import {
  AnalyticsFragment,
  ButtonComponent,
} from 'services/graphql/fragments/VxlFragments';
import { VXLResponsiveTextFragment } from 'services/graphql/fragments/VxlStyles';
import { gql } from 'urql';

export const gqlQuery = gql`
  query SmartView($input: SmartViewInput!) {
    smartView(input: $input) {
      ... on SmartViewDataView {
        callouts {
          categoryId
          iconV2
          text {
            ...VXLResponsiveTextFragment
          }
        }
        displayAnalytics {
          ...analytics
        }
        filters {
          filters {
            categoryId
            title
            detail
            filterIcon {
              ... on IllustrationStyleDictionary {
                id
                fallbackURL
                illustrationKey
              }
              ... on VXLColorType {
                color
                id
              }
            }
            clickAnalytics {
              ...analytics
            }
          }
          title
        }
        views {
          categoryId
          title
          copy
          graph {
            ... on SLLineGraphData {
              __typename
              lines {
                title
                data {
                  x
                  y {
                    ...money
                  }
                }
                color
              }
              yScale {
                labels {
                  value
                  title
                }
                maxValue
                stepSize
              }
            }
            ... on SLBarGraphData {
              __typename
              bars {
                segments {
                  amount {
                    ...money
                  }
                  color
                }
                title
              }
              yScale {
                labels {
                  value
                  title
                }
                maxValue
                stepSize
              }
            }
          }
          infoClick {
            ... on PresentBottomSheetAction {
              __typename
              id
              elements {
                ... on FullWidthTextComponent {
                  __typename
                  id
                  text {
                    ...VXLResponsiveTextFragment
                  }
                  textAlignment
                  maxLines
                }
                ... on SpacingComponent {
                  __typename
                  id
                  spacing
                }
                ...ButtonComponent
              }
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
      }
      ... on SmartViewError {
        code
        title
        message
      }
    }
  }
  ${VXLResponsiveTextFragment}
  ${AnalyticsFragment}
  ${money}
  ${ButtonComponent}
`;

export default gqlQuery;
